export { default as ReactLazySelectComponent } from './lazy-select.component'
